module.exports = __webpack_public_path__ + "bg-big_sale-mobile.jpg";